import { DefaultHomecard } from '@spotahome/ui-library';

import '@spotahome/ui-library/lib/components/Homecard/DefaultHomecard/components/HomecardWrapper.css';
import '@spotahome/ui-library/lib/components/Homecard/common/Price.css';
import '@spotahome/ui-library/lib/components/Homecard/DefaultHomecard/components/HomecardContent.css';
import '@spotahome/ui-library/lib/components/Homecard/common/HomecardImage.css';
import '@spotahome/ui-library/lib/components/Homecard/common/HomecardLabel.css';
import '@spotahome/ui-library/lib/components/Homecard/common/VerifiedLabel.css';
import '@spotahome/ui-library/lib/components/Favourite.css';
import '@spotahome/ui-library/lib/components/Rating.css';
import '@spotahome/ui-library/lib/components/LabelItem.css';

export default DefaultHomecard;
